import { render, staticRenderFns } from "./wTableSilo.vue?vue&type=template&id=48caf4ce&"
import script from "./wTableSilo.vue?vue&type=script&lang=js&"
export * from "./wTableSilo.vue?vue&type=script&lang=js&"
import style0 from "./wTableSilo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports